import type {
  ParticipationAnswer,
  PrestationQuestionData,
  ReorderPrestationQuestionsData,
  UpdateParticipationAnswersData,
} from '@cpce/shared';
import { commiteeMutation, MutationMethod } from '../mutations.utils';
import { participationAnswersQueryKey } from './prestation-questions.queries';
import { prestationsQueryKeys } from './prestations.query-keys';

export function useCreatePrestationQuestion(prestationId: number) {
  return commiteeMutation<{ id: number }, PrestationQuestionData, PrestationQuestionData>({
    url: `/commitee/:commiteeId/prestations/${prestationId}/questions`,
    method: MutationMethod.POST,
    invalidateQueries: [prestationsQueryKeys.one(prestationId)],
    body: (data) => data,
    successMessage: 'Question ajoutée',
  });
}

export function useUpdatePrestationQuestion(prestationId: number) {
  return commiteeMutation<
    void,
    PrestationQuestionData,
    { questionId: number; data: PrestationQuestionData }
  >({
    url: ({ questionId }) =>
      `/commitee/:commiteeId/prestations/${prestationId}/questions/${questionId}`,
    method: MutationMethod.PUT,
    invalidateQueries: [prestationsQueryKeys.one(prestationId)],
    body: ({ data }) => data,
    successMessage: 'Question modifiée',
  });
}

export function useRemovePrestationQuestion(prestationId: number) {
  return commiteeMutation<{ archived: boolean }, never, number>({
    url: (questionId) =>
      `/commitee/:commiteeId/prestations/${prestationId}/questions/${questionId}`,
    method: MutationMethod.DELETE,
    invalidateQueries: [prestationsQueryKeys.one(prestationId)],
    successMessage: 'Question retirée',
  });
}

export function useReorderPrestationQuestions(prestationId: number) {
  return commiteeMutation<void, ReorderPrestationQuestionsData, number[]>({
    url: `/commitee/:commiteeId/prestations/${prestationId}/questions/order`,
    method: MutationMethod.PUT,
    invalidateQueries: [prestationsQueryKeys.one(prestationId)],
    body: (questionIds) => ({ questionIds }),
    successMessage: 'Ordre des questions enregistré',
  });
}

export function useUpdateParticipationAnswers(participationId: number) {
  return commiteeMutation<
    ParticipationAnswer[],
    UpdateParticipationAnswersData,
    UpdateParticipationAnswersData
  >({
    url: `/commitee/:commiteeId/prestations/participations/${participationId}/answers`,
    method: MutationMethod.PUT,
    invalidateQueries: [participationAnswersQueryKey(participationId)],
    body: (data) => data,
    successMessage: 'Réponses enregistrées',
  });
}
